import React from "react";
import Checkbox from "./Checkbox";

export default function RadioControl(props) {
  return <Checkbox radio {...props} />;
}



// WEBPACK FOOTER //
// ./src/lib/components/FormControl/Radio.jsx